// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T18:29:39.800Z
// Property: 1801 Metrowest (ID: 6767906449162854)
// Collections: 37 amenities, 4 floorplans (live), 41 POIs, 8 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449162854",
  "property_external_id": "4767207",
  "property_zillow_url": "https://www.zillow.com/apartments/orlando-fl/1801-metrowest/5XhxtS/",
  "property_apartments_url": "https://www.apartments.com/1801-metrowest-orlando-fl/53dh5wn",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "1801-metrowest",
  "property_name": "1801 Metrowest",
  "property_website_url": "https://www.1801metrowest.com/",
  "property_domain": null,
  "property_address": "8010 Woodsedge Dr",
  "property_full_address": "8010 Woodsedge Dr, Charlotte, NC 28216",
  "property_address_1": "8010 Woodsedge Dr",
  "property_address_2": null,
  "property_address_city": "Charlotte",
  "property_address_state": "NC",
  "property_address_zip_full": "28216-1847",
  "property_address_zip": "28216",
  "property_address_country": "US",
  "property_address_county": "Mecklenburg County",
  "property_neighborhood_address": "Wedgewood",
  "property_address_latitude": "35.3470325",
  "property_address_longitude": "-80.8641971",
  "property_email": "metrowest@alapts.com",
  "property_phone": "(689) 220-6224",
  "property_call_tracking_phone": "5234567890",
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Contemporary comfort with room to live.</strong> Discover upgraded one and two bedroom apartments with chef-inspired kitchens, screened outdoor space, and access to <a href=\"/amenities\">resort-style amenities</a>—then <a href=\"/schedule-a-tour\">schedule your tour</a> to experience 1801 MetroWest.</p>",
  "property_long_description": "<p><strong>Live connected in MetroWest.</strong> At 1801 MetroWest, you’re close to the everyday essentials and the Orlando destinations that make weekends easy—from Valencia College and The Mall at Millenia to Universal Orlando, International Drive, I-4, and SR 408.</p><p>Choose from spacious <a href=\"/floor-plans\">one- and two-bedroom apartments</a> with modern chef’s kitchens, stainless-steel appliances, tile backsplashes, walk-in closets, and private screened patios or balconies. Select homes add the character you want most, including loft-style layouts, vaulted ceilings, hardwood-style flooring, pool views, and wood-burning fireplaces.</p><p>Beyond your front door, your routine feels effortless with a <a href=\"/amenities\">resort-style pool</a>, 24-hour fitness and wellness center, cycling studio, resident lounge with coffee bar, business center, secure package lockers, grilling lounge, tennis court, and a bark park for your four-legged roommate. Start your morning near the water, knock out errands nearby, then come home to a community designed for comfort, convenience, and classic Florida ease.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019d4442-a787-73f4-8bcc-94479419d142.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
    "public_id": "019d4442-a787-73f4-8bcc-94479419d142",
    "storage_key": "property/6767906449162854/019d4442-a787-73f4-8bcc-94479419d142.webp",
    "width": 1659,
    "height": 1106
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "300",
  "property_year_built": "1990",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.66666666666667",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": null,
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfddc-50e8-732c-b940-783aa5867762.webp",
  "property_primary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019cfddc-50e8-732c-b940-783aa5867762",
    "storage_key": "property/6767906449162854/019cfddc-50e8-732c-b940-783aa5867762.webp",
    "width": 325,
    "height": 147
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfddc-50e8-732c-b940-783aa5867762.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019cfddc-50e8-732c-b940-783aa5867762",
    "storage_key": "property/6767906449162854/019cfddc-50e8-732c-b940-783aa5867762.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": "https://storage.googleapis.com/6767906449162854p/test_image_upload.jpg",
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019cfdd9-c8a4-71d3-8bff-111ee22aee5d.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2713-d4f5-701a-91f4-9c4e82dc6c6b",
    "storage_key": "company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2705-ea93-721c-8d4f-e2d2a439a839",
    "storage_key": "company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "723 - 1015",
  "property_sqft_min": "723",
  "property_sqft_max": "1015",
  "property_price_range": "1302.66 - 1639.5",
  "property_price_min": "1302.66",
  "property_price_max": "1639.5",
  "property_available_units": 13,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": null,
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p>test</p>",
  "property_home_floorplans_blurb": "<p><strong>Find the layout that feels like yours.</strong> Choose a streamlined one-bedroom retreat or a two-bedroom home with space for an office, guests, or a roommate setup. Open living areas, well-appointed kitchens, spacious closets, and private patios or balconies set the tone, while select homes add granite countertops, stainless steel appliances, wood-style flooring, vaulted ceilings, fireplaces, or loft-style character.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at 1801 Metrowest.</strong> Browse sunlit living rooms, polished kitchens with stainless steel appliances and tile backsplashes, calm bedrooms, private balconies, and walk-in closets. Then step outside to poolside chairs, shaded umbrellas, grilling spaces, fitness areas, resident lounge moments, and green walkways that show the community’s relaxed rhythm.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Live close to MetroWest’s best.</strong> Enjoy a vibrant neighborhood with lake views, local restaurants and bars, parks, healthcare options, and everyday conveniences nearby. Spend the day at 187-acre Bill Frederick Park for fishing, boating, playgrounds, and camping, or head to Metrowest Golf Club for tennis, tee times, events, and dining. Afterward, grab handcrafted burgers, beers, trivia, and live music at Teak.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say 1801 Metrowest feels like home.</strong><br>Reviews highlight a welcoming atmosphere, friendly neighbors, and a leasing and maintenance team that’s helpful, responsive, and easy to work with. From smooth move-ins to quiet surroundings, well-kept amenities, pet-friendly living, package lockers, and a convenient gym, residents share plenty of reasons they recommend the community. Read the reviews to see what home can feel like here.</p>",
  "property_neighborhood_blurb": "<p><strong>Set your routine to MetroWest’s easy west-Orlando rhythm.</strong> From 1801 MetroWest, you’re positioned near the neighborhood’s lakes, local dining, and everyday corridors without feeling far from the city’s bigger energy. Spend a free afternoon at Bill Frederick Park at Turkey Lake, play a round at MetroWest Golf Club, or meet friends for burgers and craft beer at Teak Neighborhood Grill. When errands call, Kirkman Road keeps groceries, coffee, campus stops, and commuter routes close, while nearby 408 and I-4 help you move toward downtown, Millenia, the attractions, or major medical and hospitality employers. Use the map below to find your go-to spots, then <a href=\"/schedule-a-tour\">schedule a tour</a> and see how naturally the neighborhood fits your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "test",
  "property_applynow_blurb": "<p><strong>Ready to make MetroWest home?</strong> Apply online today for a spacious one- or two-bedroom apartment with modern finishes, everyday comfort, and easy access to the conveniences that keep your routine moving. Your next home at 1801 MetroWest starts here.</p>",
  "property_contactus_blurb": "<p><strong>Connect with 1801 MetroWest.</strong> Have questions about our one- and two-bedroom apartments, modern finishes, or community spaces? Reach out to the leasing team—we’re here to help you get the details you need, plan your visit, and find your way home.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at 1801 MetroWest?</strong> You’re in the right place. Explore answers about the community, leasing, apartment features, and everyday living here. If you don’t see what you need, our leasing team is happy to help you feel right at home.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that feels like yours.</strong> Choose a one-bedroom home when you want an easy, streamlined retreat, or a two-bedroom apartment when you need room for a home office, guests, or a roommate setup. Each floor plan is designed around everyday comfort, with open living areas, well-appointed kitchens, spacious closets, and private patios or balconies that give your day a natural place to unwind.</p><p>As you compare availability, look for the details that make your home feel more personal—granite countertops, decorative tile backsplashes, stainless steel appliances, wood-style flooring, vaulted ceilings, fireplaces, or loft-style character in select residences. Browse the options, explore the <a href=\"/gallery\">apartment photos</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which 1801 MetroWest floor plan fits your routine best.</p>",
  "property_gallery_blurb": "<p><strong>See the lifestyle before you step inside.</strong> Browse photos of sunlit living rooms, polished kitchens with stainless steel appliances and tile backsplashes, and bedrooms that feel calm, comfortable, and easy to make your own. As you move through the gallery, picture morning coffee on a private balcony, extra room in a walk-in closet, and the everyday ease of a home designed around how you live.</p><p>Outside, the images capture the community’s relaxed rhythm—from poolside chairs and shaded umbrellas to the resident lounge, fitness spaces, grilling area, and green walkways throughout the grounds. Explore the photos, compare details with our <a href=\"/floor-plans\">floor plans</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience 1801 Metrowest in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore life connected in MetroWest.</strong> Use the map below to find available one- and two-bedroom apartments, then see how everyday essentials, weekend destinations, and easy routes come together around 1801 MetroWest.</p>",
  "property_pets_blurb": null,
  "property_referafriend_blurb": "<p><strong>Love life at 1801 MetroWest?</strong> Share the comfort, convenience, and classic Florida ease with a friend. From spacious one- and two-bedroom homes to modern chef’s kitchens, screened patios or balconies, and easygoing community spaces, it’s all worth passing along.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access made easy.</strong> Log in to pay rent, submit maintenance requests, and manage your account in a few quick clicks—so your routine stays as effortless as life at 1801 MetroWest.</p>",
  "property_reviews_blurb": "<p><strong>Hear what home feels like from the people who live here.</strong><br>Residents consistently call out the welcoming atmosphere at 1801 Metrowest—from apartments that “feel like home” to neighbors who help the community feel easy to settle into.</p><p>You’ll also see praise for a leasing and maintenance team described as friendly, helpful, and quick to respond, whether you’re moving in, renewing, or submitting a request. Reviewers mention smooth move-in experiences, quiet surroundings, well-kept amenities, pet-friendly living, package lockers, and a gym that makes daily routines more convenient. Browse the reviews below to see why residents recommend the community—and what you can look forward to when you make it yours.</p>",
  "property_created_at": "1743713197084",
  "property_scheduletour_blurb": "<p><strong>See MetroWest living up close.</strong> Tour spacious one- and two-bedroom apartments with chef’s kitchens, walk-in closets, and private screened outdoor space—then explore the pool, fitness and wellness areas, and resident spaces that make everyday routines feel easy. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we received your inquiry.</strong><br>Our leasing team will be in touch soon. In the meantime, picture life at 1801 MetroWest: spacious one- and two-bedroom homes, modern kitchens, private screened patios or balconies, and everyday comfort in a community designed for classic Florida ease.</p>",
  "property_virtualtours_blurb": "At 1801 Metrowest in Orlando, Florida, your perfect home awaits among our thoughtfully designed one- and two-bedroom floor plans. Immerse yourself in the vibrant community with a virtual tour that showcases every detail of our apartments for rent—your future sanctuary is just a click away!",
  "property_copyright": "2025 All Rights Reserved. 1801 Metrowest",
  "property_seo_title_home": "Home | 1801 Metrowest",
  "property_seo_description_home": "Unwind at 1801 Metrowest in Orlando—modern one and two-bedroom apartments, resort-style amenities, and a vibrant community. Your perfect home awaits!",
  "property_seo_title_floorplans": "Find your ideal home at 1801 Metrowest in Orlando! Choose from stylish one and two-bedroom floor plans tailored for modern living. Browse now!",
  "property_seo_description_floorplans": "Find your ideal living space at 1801 Metrowest in Orlando! Choose from stylish one and two-bedroom floor plans that perfectly fit your lifestyle.",
  "property_seo_title_amenities": "Amenities | Orlando, Florida Apartments for Rent",
  "property_seo_description_amenities": "Unwind at 1801 Metrowest in Orlando! Enjoy luxurious amenities like a pool, fitness center, and stylish apartments with stunning features for your ideal lifestyle.",
  "property_seo_title_gallery": "Gallery | Apartments in Orlando, Florida",
  "property_seo_description_gallery": "\"Picture life at 1801 Metrowest in Orlando! Enjoy stunning amenities like a pool, fitness center, and spacious floor plans. Your dream home awaits!\"",
  "property_seo_title_virtualtours": "Virtual Tours | 1801 Metrowest Apartments",
  "property_seo_description_virtualtours": "Experience Orlando living at 1801 Metrowest! Take a virtual tour to see our stylish one- and two-bedroom apartments that redefine comfort and convenience.",
  "property_seo_title_interactivemap": "Interactive Map | 1801 Metrowest Apartments",
  "property_seo_description_interactivemap": "Find your perfect apartment at 1801 Metrowest in Orlando! Enjoy luxurious amenities, scenic views, and an interactive map to help you choose your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Orlando, Florida",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhoods surrounding 1801 Metrowest in Orlando. Dive into local gems and hotspots near our one- and two-bedroom apartments!",
  "property_seo_title_contact": "Contact Us | 1801 Metrowest",
  "property_seo_description_contact": "Reach out to our leasing team at 1801 Metrowest in Orlando! Explore our stylish one and two-bedroom floor plans and find your perfect apartment today.",
  "property_seo_title_faqs": "FAQs | Apartments in Orlando, Florida",
  "property_seo_description_faqs": "Unlock the secrets of 1801 Metrowest! Get insights on our one and two-bedroom apartments, amenities, and community life. Your questions, answered in one spot!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Orlando, Florida",
  "property_seo_description_reviews": "Experience life at 1801 Metrowest in Orlando! Read resident reviews and see why our one and two-bedroom apartments with top-notch amenities feel like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Orlando, Florida",
  "property_seo_description_applynow": "Experience vibrant living at 1801 Metrowest in Orlando, featuring spacious floor plans, luxurious amenities like a pool and fitness center, and a welcoming atmosphere. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | 1801 Metrowest",
  "property_seo_description_residentaccess": "Access your resident portal at 1801 Metrowest in Orlando! Pay rent, schedule maintenance, and manage your living experience with ease—your home awaits!",
  "property_seo_title_referafriend": "Refer A Friend | 1801 Metrowest",
  "property_seo_description_referafriend": "\"Refer a friend to 1801 Metrowest in Orlando! Celebrate great friendships and enjoy vibrant living together in our welcoming apartment community.\"",
  "property_seo_title_scheduletour": "Schedule a Tour | 1801 Metrowest",
  "property_seo_description_scheduletour": "Experience vibrant living at 1801 Metrowest in Orlando! Connect with our community and schedule a tour today to see your future home in a prime location!",
  "property_seo_title_privacy": "Privacy Policy | 1801 Metrowest",
  "property_seo_description_privacy": "Learn how 1801 Metrowest in Orlando safeguards your information. Trust, transparency, and your privacy are our top priorities. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | 1801 Metrowest",
  "property_seo_description_accessibility": "Experience true inclusivity at 1801 Metrowest in Orlando. Our Accessibility Statement reflects our commitment to ensuring everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | 1801 Metrowest",
  "property_seo_description_sitemap": "Navigate your way to vibrant living at 1801 Metrowest in Orlando. Access our sitemap for an organized overview of stunning amenities and apartment options!",
  "property_seo_title_thankyou": "Thank You | 1801 Metrowest",
  "property_seo_description_thankyou": "Thank you for reaching out! A member of the 1801 Metrowest team will connect with you soon to help you elevate your Orlando living experience.",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1787594973864",
  "amenities": [
    {
      "id": "ec_bfaed105d22505fdd9898c9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa46fbbd96853585bfd84e0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9411d17082a2f88ec3699f19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-Up",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0cb7acd7d45fc5a9069b1ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0435ff3c4602c21dc7e767ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d5d6c5b48f9c733f3bd11be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7da396065840fb8afe86507",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5845449c1f726a3e3d21d3a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "American Landmark 360 Resident Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9433411d003a55f2627eef5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Bark Park for Furry Friends",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9d66ad6af9cd0c1874ec749",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Community Grilling Area/Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ffd4f169253de76b8c7fd6d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Concierge Package System",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21ec29f370bd4e5c90e09c20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Convenient 24/7 Online Resident Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8fc4d0d15f51389ac05f13c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Cycling Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c4fbdc03afce0e9a0fa80ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Decorative Tile Backsplash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_096495e2d2cf9d8e632bac45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Inspired Flooring*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_458212454b76323a91849bb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Loft Style Apartments*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ad0f1db86de276c4b973886",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Patios and Balconies",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7de6c26c0802def956877e07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Resident Lounge w/Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d5de91d5161ec452b4de749",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Sleek Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_458a8a12d4bb622d2724d527",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3f7ff94f0b866cc58f6eeb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b76e90169fb9b610a0caec1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Wi-Fi and 250 Cable Channels",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0b9a4862bab3e2c5c85aa91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Wood Burning Fireplaces*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63eb30afe9f0edb2fa9ced33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45d049697d594b354b04114d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9dd29af6361d147d60f4a4ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8192414a6a9e60d0c13750a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_127cbb6c7e12b32c099970c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6586c8a415566c73c2610a7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ae9df4ff6a02f6d2d83d8f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_97a628d1e765367f2419e6ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e38e6795894798a11cb6c20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7609a037fc6397ea09062b60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8e88e4da6db9d83bff05120",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Vaulted Ceiling",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_afb356d4500ae1d64be1a402",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_395c3173a9669a223ecae85f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba3530d6426e8b81a2dc0c10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [],
  "neighborhood_pois": [
    {
      "id": "custom_46179d01-ac7f-4e43-81c5-10f3b87df317",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "McDonald's",
      "poi_type": "Restaurants",
      "poi_address": "6875 Sand Lake Rd, Orlando, FL 32819, USA",
      "poi_short_description": "Chain fast-food restaurant with burgers and breakfast items, plus pizza and a play area with an arcade.",
      "poi_long_description": "Visitors say this fast food restaurant offers a unique dining experience with brick oven pizza, pasta, and Philly cheese steak sandwiches, alongside classic McDonald's fare like burgers, nuggets, and fries. They also highlight the family-friendly atmosphere with a large play area and arcade on the second floor, making it a popular spot for tourists and locals alike.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-98ca-74fa-9f3f-04cd017407b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-98ca-74fa-9f3f-04cd017407b5",
        "storage_key": "property/6767906449162854/019cfdda-98ca-74fa-9f3f-04cd017407b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mcdonalds.com/us/en-us/location/FL/ORLANDO/6875-SANDLAKE-RD/3896.html?cid=RF:YXT:GMB::Clicks",
      "poi_directions_map_url": "https://maps.google.com/?cid=9098907094195067642",
      "poi_item_slug": "mcdonalds",
      "poi_latitude": "28.4504681",
      "poi_longitude": "-81.4714229",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 424-444-1169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e479-745a-ab43-23f20777c643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e479-745a-ab43-23f20777c643",
        "storage_key": "property/6767906449162854/019cfdda-e479-745a-ab43-23f20777c643.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu7bMNFV-54gR-lrHScvPRX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_d4ed7e1a-4b86-4dc1-8be4-1a4ce185ee35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Topgolf Orlando",
      "poi_type": "Restaurants",
      "poi_address": "9295 Universal Blvd, Orlando, FL 32819, USA",
      "poi_short_description": "Restaurant offering an array of games, including golf, plus cocktails and comfort food.",
      "poi_long_description": "Golfers say this entertainment venue offers a fun experience with good wings and a wide selection of beers. They also highlight the friendly and helpful staff, and many appreciate the accommodating service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-980b-7535-bb2f-a939f9553b7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-980b-7535-bb2f-a939f9553b7d",
        "storage_key": "property/6767906449162854/019cfdda-980b-7535-bb2f-a939f9553b7d.webp",
        "width": 1024,
        "height": 697
      },
      "poi_business_url": "https://topgolf.com/us/orlando/",
      "poi_directions_map_url": "https://maps.google.com/?cid=605090155988300880",
      "poi_item_slug": "topgolf-orlando",
      "poi_latitude": "28.435964",
      "poi_longitude": "-81.4635345",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 407-218-7714",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e479-745a-ab43-23f20777c643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e479-745a-ab43-23f20777c643",
        "storage_key": "property/6767906449162854/019cfdda-e479-745a-ab43-23f20777c643.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7rQ1U5-54gRULTEfEq2ZQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fd2f9f9f-2bd6-4c15-a42e-13c5be8a53a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "8032 International Dr, Orlando, FL 32819, USA",
      "poi_short_description": "Casual American buffet chain featuring homestyle classics, a salad bar, and a chocolate fountain.",
      "poi_long_description": "Diners say this buffet restaurant offers a wide variety of food, including steak, fried chicken, fried fish, and a chocolate fountain. They also highlight the value for money, especially for families and seniors, and the attentive staff.\n\nSome reviews mention the restaurant can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-97e4-7566-9ea2-7a6c3ab19e7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-97e4-7566-9ea2-7a6c3ab19e7c",
        "storage_key": "property/6767906449162854/019cfdda-97e4-7566-9ea2-7a6c3ab19e7c.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/755/golden-corral-international-drive?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=755&utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=755",
      "poi_directions_map_url": "https://maps.google.com/?cid=4973655548268135764",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "28.4488463",
      "poi_longitude": "-81.47261979999999",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 407-788-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e479-745a-ab43-23f20777c643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e479-745a-ab43-23f20777c643",
        "storage_key": "property/6767906449162854/019cfdda-e479-745a-ab43-23f20777c643.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFVfGJat_54gRVEWsnV75BUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_568a5d73-653d-4d73-826f-7e81bb209a6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "4200 Conroy Rd Space A-148, Orlando, FL 32839, USA",
      "poi_short_description": "Casual restaurant chain featuring a large menu of American fare and signature cheesecakes.",
      "poi_long_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-98a8-7584-80d6-c33e1981c6c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-98a8-7584-80d6-c33e1981c6c5",
        "storage_key": "property/6767906449162854/019cfdda-98a8-7584-80d6-c33e1981c6c5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/fl/orlando-56.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=10113767537065878974",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "28.486024",
      "poi_longitude": "-81.4313457",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 407-226-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e479-745a-ab43-23f20777c643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e479-745a-ab43-23f20777c643",
        "storage_key": "property/6767906449162854/019cfdda-e479-745a-ab43-23f20777c643.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvzy4k6h-54gRvmWwa_1RW4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_58a46d42-e96e-44c8-af8b-68267e3ecf64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Dave & Buster's Orlando",
      "poi_type": "Restaurants",
      "poi_address": "8986 International Dr, Orlando, FL 32819, USA",
      "poi_short_description": "Chain restaurant and arcade offering a sports bar, a full menu, and simulators.",
      "poi_long_description": "People say this restaurant and entertainment venue offers delicious chicken wings, burgers, and fries, and they praise the lively atmosphere with TVs playing sports and a wide selection of arcade games. They also highlight the friendly and attentive staff, and many appreciate the half-price Wednesdays deal.\n\nSome reviews mention the wait times for food can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-9e6c-733f-ba3c-1fed7042687e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-9e6c-733f-ba3c-1fed7042687e",
        "storage_key": "property/6767906449162854/019cfdda-9e6c-733f-ba3c-1fed7042687e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/orlando",
      "poi_directions_map_url": "https://maps.google.com/?cid=8086656828342131773",
      "poi_item_slug": "dave--busters-orlando",
      "poi_latitude": "28.436304",
      "poi_longitude": "-81.473203",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 407-541-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e479-745a-ab43-23f20777c643.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e479-745a-ab43-23f20777c643",
        "storage_key": "property/6767906449162854/019cfdda-e479-745a-ab43-23f20777c643.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xePR7N_54gRPdzRWYqTOXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b6d137e4-1327-477f-ae8b-3cfc659b4e97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Orlando International Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "4951 International Dr, Orlando, FL 32819, USA",
      "poi_short_description": "Shoppers can score discounts of 25–65% at this outlet center featuring designer and brand-name stores.",
      "poi_long_description": "Shoppers say this outlet mall offers a wide variety of stores with great deals on name brands, a spacious food court with plenty of options, and a clean, well-maintained atmosphere. They also highlight the excellent shopping experience, with many mentioning the fantastic prices and bargains that can be found.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-9fd0-73bf-b42a-504389929c25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-9fd0-73bf-b42a-504389929c25",
        "storage_key": "property/6767906449162854/019cfdda-9fd0-73bf-b42a-504389929c25.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/orlando-international",
      "poi_directions_map_url": "https://maps.google.com/?cid=8037570302448714225",
      "poi_item_slug": "orlando-international-premium-outlets",
      "poi_latitude": "28.4746714",
      "poi_longitude": "-81.45152879999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 407-352-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e47b-76fb-bc6f-100165840d0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e47b-76fb-bc6f-100165840d0e",
        "storage_key": "property/6767906449162854/019cfdda-e47b-76fb-bc6f-100165840d0e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEVALZBp_54gR8UGv7povi28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6ae416bf-4f99-4bc4-a862-d4b02d7da715",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "The Mall at Millenia",
      "poi_type": "Shopping & Retail",
      "poi_address": "4200 Conroy Rd, Orlando, FL 32839, USA",
      "poi_short_description": "Shopping center with upscale shops, a glass ceiling, and a food court, plus valet parking.",
      "poi_long_description": "High-end mall with designer clothes, decor & jewelry plus eateries in sleek, glass-ceilinged space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-9e7a-7122-b454-daa76231f20e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-9e7a-7122-b454-daa76231f20e",
        "storage_key": "property/6767906449162854/019cfdda-9e7a-7122-b454-daa76231f20e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.mallatmillenia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16405611967887564916",
      "poi_item_slug": "the-mall-at-millenia",
      "poi_latitude": "28.4859448",
      "poi_longitude": "-81.4310557",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 407-363-3555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e47b-76fb-bc6f-100165840d0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e47b-76fb-bc6f-100165840d0e",
        "storage_key": "property/6767906449162854/019cfdda-e47b-76fb-bc6f-100165840d0e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJV9nGk6h-54gRdODVBCpxrOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_96e1a8de-9055-4f7d-9050-b62a363df5b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Universal CityWalk Orlando",
      "poi_type": "Shopping & Retail",
      "poi_address": "6000 Universal Blvd, Orlando, FL 32819, USA",
      "poi_short_description": "Dining, nightlife, and entertainment center at Universal Orlando Resort with a lagoon, mini-golf, and a cinema.",
      "poi_long_description": "Diners say this shopping center offers a wide variety of restaurants, including the Toothsome Chocolate Emporium & Savory Feast Kitchen™, and Voodoo Doughnut, and many recommend making reservations. They also highlight the friendly staff, clean environment, and fun, nostalgic atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-a03e-76aa-8007-544f22d056cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-a03e-76aa-8007-544f22d056cc",
        "storage_key": "property/6767906449162854/019cfdda-a03e-76aa-8007-544f22d056cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.universalorlando.com/web/en/us/theme-parks/citywalk",
      "poi_directions_map_url": "https://maps.google.com/?cid=8937435963939553529",
      "poi_item_slug": "universal-citywalk-orlando",
      "poi_latitude": "28.4729899",
      "poi_longitude": "-81.46588679999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 407-363-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e47b-76fb-bc6f-100165840d0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e47b-76fb-bc6f-100165840d0e",
        "storage_key": "property/6767906449162854/019cfdda-e47b-76fb-bc6f-100165840d0e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEyMWSOd-54gR-QBrGagmCHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_dc7ee850-90bf-47ad-9563-39cf4380cb30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Orlando Outlet Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "5269 International Dr, Orlando, FL 32819, USA",
      "poi_short_description": "Outlet shopping center with various brand-name clothing stores, a food court, and a restroom.",
      "poi_long_description": "Outlet mall near Universal Studios with designer clothing, luggage & gift retailers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-a67f-7153-a1f0-b183125761cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-a67f-7153-a1f0-b183125761cb",
        "storage_key": "property/6767906449162854/019cfdda-a67f-7153-a1f0-b183125761cb.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/orlando-outlet-marketplace",
      "poi_directions_map_url": "https://maps.google.com/?cid=11087730454640012286",
      "poi_item_slug": "orlando-outlet-marketplace",
      "poi_latitude": "28.4681384",
      "poi_longitude": "-81.4521101",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-352-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e47b-76fb-bc6f-100165840d0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e47b-76fb-bc6f-100165840d0e",
        "storage_key": "property/6767906449162854/019cfdda-e47b-76fb-bc6f-100165840d0e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJm8R4Q_F-54gR_isZahqI35k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6dc4977e-65cb-4108-b3bf-fbfea172747d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "4092 Eastgate Dr, Orlando, FL 32839, USA",
      "poi_short_description": "Chain home-furnishings store with an in-house restaurant and children's playroom.",
      "poi_long_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-a6e6-74c9-8aca-6c5ebe6f3490.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-a6e6-74c9-8aca-6c5ebe6f3490",
        "storage_key": "property/6767906449162854/019cfdda-a6e6-74c9-8aca-6c5ebe6f3490.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/orlando/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=orlando",
      "poi_directions_map_url": "https://maps.google.com/?cid=5545860379828309272",
      "poi_item_slug": "ikea",
      "poi_latitude": "28.4826518",
      "poi_longitude": "-81.4275382",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e47b-76fb-bc6f-100165840d0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e47b-76fb-bc6f-100165840d0e",
        "storage_key": "property/6767906449162854/019cfdda-e47b-76fb-bc6f-100165840d0e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJwGhXB1854gRGE2U2aHa9kw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_7702b9df-51b3-43db-b4b4-90e3ff37e631",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Valencia College West Campus",
      "poi_type": "Education",
      "poi_address": "SSB - Student Services Building, 1800 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-a87f-70ce-90dc-ec1fb63666cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-a87f-70ce-90dc-ec1fb63666cb",
        "storage_key": "property/6767906449162854/019cfdda-a87f-70ce-90dc-ec1fb63666cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://valenciacollege.edu/locations/west/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6740659856168592299",
      "poi_item_slug": "valencia-college-west-campus",
      "poi_latitude": "28.5213883",
      "poi_longitude": "-81.46483549999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 407-299-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e475-727c-96fc-d4a510688661.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e475-727c-96fc-d4a510688661",
        "storage_key": "property/6767906449162854/019cfdda-e475-727c-96fc-d4a510688661.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0XspYxh554gRqyOq9myii10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5d42930e-d4f3-41e9-89ba-02ec434685aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Orlando Public Library",
      "poi_type": "Education",
      "poi_address": "101 E Central Blvd, Orlando, FL 32801, USA",
      "poi_short_description": "Part of the Orange County Library System, this welcoming building includes a used bookstore and a variety of classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-a77e-7107-8271-101578bbb9cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-a77e-7107-8271-101578bbb9cb",
        "storage_key": "property/6767906449162854/019cfdda-a77e-7107-8271-101578bbb9cb.webp",
        "width": 1280,
        "height": 838
      },
      "poi_business_url": "https://ocls.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16508134675250481487",
      "poi_item_slug": "orlando-public-library",
      "poi_latitude": "28.5424041",
      "poi_longitude": "-81.37661419999999",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-835-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e475-727c-96fc-d4a510688661.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e475-727c-96fc-d4a510688661",
        "storage_key": "property/6767906449162854/019cfdda-e475-727c-96fc-d4a510688661.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu8iKN_x654gRTwmd9gWtGOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_4f710fe7-ba7b-4309-9370-081a055f3bfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Universal Studios Florida",
      "poi_type": "Entertainment",
      "poi_address": "6000 Universal Blvd, Orlando, FL 32819, USA",
      "poi_short_description": "Famous, sprawling amusement park featuring movie-themed rides, attractions & entertainment.",
      "poi_long_description": "Visitors say this theme park offers a variety of thrilling rides and attractions, including The Simpsons Ride, Fast & Furious Supercharged, and the Mummy ride, and many recommend purchasing an annual pass for frequent visits. They also highlight the family-friendly atmosphere, amazing team members, and incredible experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-adae-763d-bf1b-3e1c5947f93d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-adae-763d-bf1b-3e1c5947f93d",
        "storage_key": "property/6767906449162854/019cfdda-adae-763d-bf1b-3e1c5947f93d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.universalorlando.com/web/en/us/theme-parks/universal-studios-florida?utm_source=google&utm_medium=organic&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=17980015666189870497",
      "poi_item_slug": "universal-studios-florida",
      "poi_latitude": "28.4793754",
      "poi_longitude": "-81.4685422",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 407-363-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdd8VlMN-54gRoaU0d_zYhfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_39925dfc-f858-4725-93e7-32d8da230066",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Kia Center",
      "poi_type": "Entertainment",
      "poi_address": "400 W Church St, Orlando, FL 32801, USA",
      "poi_short_description": "Sporting events and big-name music acts are on the schedule at this venue.",
      "poi_long_description": "Fans say this arena hosts exciting Orlando Magic games and concerts, and they praise the friendly and helpful staff. They also highlight the clean and well-maintained facilities, and the overall fun and engaging atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-adad-746a-8a67-c00b4c3bbbba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-adad-746a-8a67-c00b4c3bbbba",
        "storage_key": "property/6767906449162854/019cfdda-adad-746a-8a67-c00b4c3bbbba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kiacenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17854814920010600848",
      "poi_item_slug": "kia-center",
      "poi_latitude": "28.5392214",
      "poi_longitude": "-81.3838535",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-440-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVcr7Ufp654gRkJGTJZILyfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_f52e3a9b-5c07-4c03-a5b1-f7682d811965",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Universal Islands of Adventure",
      "poi_type": "Entertainment",
      "poi_address": "6000 Universal Blvd, Orlando, FL 32819, USA",
      "poi_short_description": "Extreme thrill rides & the Wizarding World of Harry Potter attract crowds to this Universal park.",
      "poi_long_description": "Visitors say this theme park offers thrilling roller coasters like Hagrid’s Magical Creatures Motorbike Adventure and Jurassic World VelociCoaster, and they praise the immersive experiences and family-friendly atmosphere. They also highlight the value of annual passes, which provide significant savings for frequent visits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-adc7-7007-8de8-07e18972b9fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-adc7-7007-8de8-07e18972b9fa",
        "storage_key": "property/6767906449162854/019cfdda-adc7-7007-8de8-07e18972b9fa.webp",
        "width": 750,
        "height": 750
      },
      "poi_business_url": "https://www.universalorlando.com/web/en/us/theme-parks/islands-of-adventure",
      "poi_directions_map_url": "https://maps.google.com/?cid=1397247755829479923",
      "poi_item_slug": "universal-islands-of-adventure",
      "poi_latitude": "28.4716879",
      "poi_longitude": "-81.4701971",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 407-363-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRBCrN9-54gR84ltVW4FZBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_a0890ac8-bc03-4dc9-a2e8-b676f8e439a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Universal Volcano Bay",
      "poi_type": "Entertainment",
      "poi_address": "6000 Universal Blvd, Orlando, FL 32819, USA",
      "poi_short_description": "Universal Studio's sprawling water park offers high-thrill slides & rides, plus low-key pools.",
      "poi_long_description": "Universal Studio's sprawling water park offers high-thrill slides & rides, plus low-key pools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-b07f-7144-b167-457241f12e8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-b07f-7144-b167-457241f12e8d",
        "storage_key": "property/6767906449162854/019cfdda-b07f-7144-b167-457241f12e8d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.universalorlando.com/web/en/us/theme-parks/volcano-bay",
      "poi_directions_map_url": "https://maps.google.com/?cid=17970149011548396084",
      "poi_item_slug": "universal-volcano-bay",
      "poi_latitude": "28.4619885",
      "poi_longitude": "-81.4724528",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 407-363-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWdHR8wJ_54gRNNot6lDLYvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_77df9658-2b10-4839-870a-cb1524234e3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Camping World Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1 Citrus Bowl Place, Orlando, FL 32805, USA",
      "poi_short_description": "Stadium used for football and soccer games, plus concerts and other entertainment events.",
      "poi_long_description": "Longtime destination seating 65,000+ presents rock concerts, wrestling, soccer & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-b35c-732f-8d8a-3499d1e42961.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-b35c-732f-8d8a-3499d1e42961",
        "storage_key": "property/6767906449162854/019cfdda-b35c-732f-8d8a-3499d1e42961.webp",
        "width": 781,
        "height": 477
      },
      "poi_business_url": "http://www.campingworldstadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2953674804500755934",
      "poi_item_slug": "camping-world-stadium",
      "poi_latitude": "28.5390192",
      "poi_longitude": "-81.40275249999999",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 407-440-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e7c5-713e-b318-6a56a020191a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e7c5-713e-b318-6a56a020191a",
        "storage_key": "property/6767906449162854/019cfdda-e7c5-713e-b318-6a56a020191a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJExJCtLR754gR3vVJ4JWP_Sg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_53c1099e-969a-460e-8757-01b285655208",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "IRON RELIGION GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "5247 International Dr, Orlando, FL 32819, USA",
      "poi_short_description": "Gym offering 24/7 access and a variety of equipment, including plate-loaded machines.",
      "poi_long_description": "A 24/7 gym offering cardio machines & free weights, plus personal training & a store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-b35d-74f8-8403-9a66cbcf041a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-b35d-74f8-8403-9a66cbcf041a",
        "storage_key": "property/6767906449162854/019cfdda-b35d-74f8-8403-9a66cbcf041a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ironreligiongym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9192018648393734643",
      "poi_item_slug": "iron-religion-gym",
      "poi_latitude": "28.4689554",
      "poi_longitude": "-81.453377",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-530-9009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUbeZj-t-54gR81lGYkKckH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a1cd2eff-6012-4d8b-9e95-aff1102f3598",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Dr. P. Phillips YMCA Family Center",
      "poi_type": "Health and Wellness",
      "poi_address": "7000 Dr Phillips Blvd, Orlando, FL 32819, USA",
      "poi_short_description": "Nonprofit center offering a pool, gym, and fitness classes, as well as a cafe and child care.",
      "poi_long_description": "Visitors say this gym offers a variety of exercise classes, including Zumba, Latin cardio, and pickleball, and has a spacious layout with well-maintained equipment. They also highlight the friendly and helpful staff, and the clean and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-b484-7169-bfb7-5566371b0e71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-b484-7169-bfb7-5566371b0e71",
        "storage_key": "property/6767906449162854/019cfdda-b484-7169-bfb7-5566371b0e71.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ymcacf.org/locations/drphillips/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8534077275878617235",
      "poi_item_slug": "dr-p-phillips-ymca-family-center",
      "poi_latitude": "28.4601395",
      "poi_longitude": "-81.4928718",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 407-351-9417",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwO9lwx_54gRk3B6IhEib3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ca8fd273-bbe8-409e-95db-a228c9036bec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Fitness CF",
      "poi_type": "Health and Wellness",
      "poi_address": "7733 Turkey Lake Rd, Orlando, FL 32819, USA",
      "poi_short_description": "Fitness center with a variety of equipment and classes, plus child care and personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-b67d-718c-b5b2-fc0cca55faa9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-b67d-718c-b5b2-fc0cca55faa9",
        "storage_key": "property/6767906449162854/019cfdda-b67d-718c-b5b2-fc0cca55faa9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fitnesscfgyms.com/orlandofl/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2282164702038007699",
      "poi_item_slug": "fitness-cf",
      "poi_latitude": "28.4528715",
      "poi_longitude": "-81.4766254",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 407-226-9996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY8T2pQB_54gRkx_pf7Tgqx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d55801e4-f6cc-482c-9721-0216dd99343c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4792 S Kirkman Rd, Orlando, FL 32811, USA",
      "poi_short_description": "Chain fitness center with a pool, basketball court, and sauna, plus group classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-b8e0-736b-a513-d725043ffff7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-b8e0-736b-a513-d725043ffff7",
        "storage_key": "property/6767906449162854/019cfdda-b8e0-736b-a513-d725043ffff7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1058&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1227584321160174495",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "28.4922898",
      "poi_longitude": "-81.4605285",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 407-362-0645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN3Sz5M1-54gRn1uXom9BCRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_48d1cfaa-2bd8-4fae-865c-2ec8f2db70cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Game Point Event Center",
      "poi_type": "Health and Wellness",
      "poi_address": "6700 Kingspointe Pkwy, Orlando, FL 32819, USA",
      "poi_short_description": "Vast sports complex with volleyball courts and a basketball court, plus clinics, leagues, and tournaments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-ba66-7254-add5-e9802f6993ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-ba66-7254-add5-e9802f6993ca",
        "storage_key": "property/6767906449162854/019cfdda-ba66-7254-add5-e9802f6993ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://gamepointevents.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16841312730547655292",
      "poi_item_slug": "game-point-event-center",
      "poi_latitude": "28.4571788",
      "poi_longitude": "-81.4383022",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 407-351-8433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS5F4euV_54gRfJKOB7NcuOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_93362f08-adda-41da-a34a-6670ac90ed94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8956 Turkey Lake Rd #1000, Orlando, FL 32819, USA",
      "poi_short_description": "Chain gym featuring a variety of equipment, tanning facilities, and spa services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-b9f5-7240-8344-a7e7421fc40b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-b9f5-7240-8344-a7e7421fc40b",
        "storage_key": "property/6767906449162854/019cfdda-b9f5-7240-8344-a7e7421fc40b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/orlando-dr-phillips-fl?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16641675003733012274",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "28.444109",
      "poi_longitude": "-81.4756199",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 407-608-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsRPNTqx_54gRMu8AmT4b8-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_58f9f5ef-5a9f-4610-9865-c7be4b4415f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Top Gun All Stars of Orlando",
      "poi_type": "Health and Wellness",
      "poi_address": "631 S Bluford Ave, Ocoee, FL 34761, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-bd5f-720e-9c5e-28413a51cac6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-bd5f-720e-9c5e-28413a51cac6",
        "storage_key": "property/6767906449162854/019cfdda-bd5f-720e-9c5e-28413a51cac6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.topgunallstars.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7039369967864057772",
      "poi_item_slug": "top-gun-all-stars-of-orlando",
      "poi_latitude": "28.5606291",
      "poi_longitude": "-81.54459829999999",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 407-299-1911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e475-727c-96fc-d4a510688661.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e475-727c-96fc-d4a510688661",
        "storage_key": "property/6767906449162854/019cfdda-e475-727c-96fc-d4a510688661.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtcaceHh454gRrA8XibDdsGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1594a2d7-10b6-4990-90ee-9eb294dbb737",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Downtown Orlando YMCA Family Center",
      "poi_type": "Health and Wellness",
      "poi_address": "433 N Mills Ave, Orlando, FL 32803, USA",
      "poi_short_description": "Longtime community hub offering a pool, basketball court, and locker rooms, plus childcare.",
      "poi_long_description": "Visitors say this YMCA has a great childcare center, a variety of classes, and a large selection of activities. They also highlight the friendly and helpful staff, the clean facilities, and the family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-beb5-705b-bd79-e59ee43ffff8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-beb5-705b-bd79-e59ee43ffff8",
        "storage_key": "property/6767906449162854/019cfdda-beb5-705b-bd79-e59ee43ffff8.webp",
        "width": 800,
        "height": 534
      },
      "poi_business_url": "https://ymcacf.org/locations/downtown/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1302243264666854611",
      "poi_item_slug": "downtown-orlando-ymca-family-center",
      "poi_latitude": "28.5489328",
      "poi_longitude": "-81.3633658",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 407-896-6901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ74jKtPV754gR0-ScgVl_EhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1a27856b-ad45-4c8f-bd74-654f5f4bdb0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "15 W Crystal Lake St, Orlando, FL 32806, USA",
      "poi_short_description": "Chain health club offering cardio and weight machines, group classes, and personal trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-c14f-734d-bc26-003964ed8116.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-c14f-734d-bc26-003964ed8116",
        "storage_key": "property/6767906449162854/019cfdda-c14f-734d-bc26-003964ed8116.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1381&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14704625177333589789",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "28.5148411",
      "poi_longitude": "-81.37722959999999",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 321-732-6018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOVbEKAB754gRHec7urBSEcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5c87c7eb-f549-485a-a0b1-f4ffd4d3e451",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9 W Gore St, Orlando, FL 32801, USA",
      "poi_short_description": "Chain fitness center with tanning and spa services, and a membership requirement.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-c095-721e-a077-ae37f1324e54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-c095-721e-a077-ae37f1324e54",
        "storage_key": "property/6767906449162854/019cfdda-c095-721e-a077-ae37f1324e54.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/orlando-holden-ave-and-orange-blossom-trail-fl?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2377134856353080722",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "28.5313969",
      "poi_longitude": "-81.3771211",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 407-985-4349",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtxluw4h754gRkuUfqI5H_SA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_58448ae8-bb7c-4952-a657-369973c9137d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Orlando Health Orlando Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "52 W Underwood St, Orlando, FL 32806, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-c44f-77ea-a96f-cc564715418f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-c44f-77ea-a96f-cc564715418f",
        "storage_key": "property/6767906449162854/019cfdda-c44f-77ea-a96f-cc564715418f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.orlandohealth.com/facilities/orlando-regional-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=24878703848122848",
      "poi_item_slug": "orlando-health-orlando-regional-medical-center",
      "poi_latitude": "28.526485",
      "poi_longitude": "-81.3778912",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 321-841-5210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e7c8-75cb-9032-d78a28b05e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e7c8-75cb-9032-d78a28b05e9e",
        "storage_key": "property/6767906449162854/019cfdda-e7c8-75cb-9032-d78a28b05e9e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-9TcQw9754gR4OlWoQxjWAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e7ed4ee5-0bea-46c5-9c83-3651bff6bb16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Orlando Health Arnold Palmer Hospital for Children",
      "poi_type": "Health and Wellness",
      "poi_address": "92 W Miller St, Orlando, FL 32806, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-c44f-77ea-a96f-cbc94bc3ce11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-c44f-77ea-a96f-cbc94bc3ce11",
        "storage_key": "property/6767906449162854/019cfdda-c44f-77ea-a96f-cbc94bc3ce11.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.arnoldpalmerhospital.com/facilities/arnold-palmer-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=17313645339132798613",
      "poi_item_slug": "orlando-health-arnold-palmer-hospital-for-children",
      "poi_latitude": "28.523166",
      "poi_longitude": "-81.3797981",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 407-649-9111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e7c8-75cb-9032-d78a28b05e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e7c8-75cb-9032-d78a28b05e9e",
        "storage_key": "property/6767906449162854/019cfdda-e7c8-75cb-9032-d78a28b05e9e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYyAOQl754gRlaYbTrRsRvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f933a912-3fbc-4b09-9f1f-0ae60c870ce9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Lake Eola Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "512 E Washington St, Orlando, FL 32801, USA",
      "poi_short_description": "Lakeside park featuring a walking path, a playground, a swan boat, and a Sunday farmers' market.",
      "poi_long_description": "Visitors say this park offers a relaxing atmosphere with swan boats, a walking path, and live music. They also highlight the beautiful scenery, abundance of wildlife, and family-friendly activities, such as the farmers market and festivals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-c6a4-7086-bb5f-fab215def273.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-c6a4-7086-bb5f-fab215def273",
        "storage_key": "property/6767906449162854/019cfdda-c6a4-7086-bb5f-fab215def273.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orlando.gov/Parks-the-Environment/Directory/Lake-Eola-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17813674956509683155",
      "poi_item_slug": "lake-eola-park",
      "poi_latitude": "28.5427628",
      "poi_longitude": "-81.37092919999999",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 407-246-4484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e7c3-7576-8028-28ed777ba203.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e7c3-7576-8028-28ed777ba203",
        "storage_key": "property/6767906449162854/019cfdda-e7c3-7576-8028-28ed777ba203.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu3hNU-N654gR0x0I9_3iNvc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_248534fa-bfdd-448b-9950-5668ad8cbfbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Bill Frederick Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3401 S Hiawassee Rd, Orlando, FL 32835, USA",
      "poi_short_description": "Recreation site offering a pool, playground, disc golf, and picnic areas, plus cabins.",
      "poi_long_description": "Visitors say this park offers a beautiful lake, spacious campsites, and fun disc golf courses. They also highlight the friendly staff, clean restrooms, and peaceful atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-cb32-7259-9a1b-3ed6af96c045.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-cb32-7259-9a1b-3ed6af96c045",
        "storage_key": "property/6767906449162854/019cfdda-cb32-7259-9a1b-3ed6af96c045.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityoforlando.net/parks/bill-frederick-park-turkey-lake/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3622395875443829037",
      "poi_item_slug": "bill-frederick-park",
      "poi_latitude": "28.5071117",
      "poi_longitude": "-81.48389829999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 407-246-4486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e7c3-7576-8028-28ed777ba203.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e7c3-7576-8028-28ed777ba203",
        "storage_key": "property/6767906449162854/019cfdda-e7c3-7576-8028-28ed777ba203.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnRQu2NN454gRLWmrP9tVRTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0d54de56-cf32-4560-a3e3-73334d3b1901",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Cypress Grove Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "290 Holden Ave, Orlando, FL 32839, USA",
      "poi_short_description": "Park with a lake, playground, volleyball court, picnic areas, and walking trail.",
      "poi_long_description": "Ninety-acre park around a 1920's mansion & lake with a playground, picnic areas & sports courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-cc49-7358-b4e4-a20b1f0dcd6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-cc49-7358-b4e4-a20b1f0dcd6d",
        "storage_key": "property/6767906449162854/019cfdda-cc49-7358-b4e4-a20b1f0dcd6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ocfl.net/CultureParks/Parks.aspx?m=lstaz",
      "poi_directions_map_url": "https://maps.google.com/?cid=1403933553890391929",
      "poi_item_slug": "cypress-grove-park",
      "poi_latitude": "28.4920336",
      "poi_longitude": "-81.37837069999999",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 407-254-6770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e7c3-7576-8028-28ed777ba203.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e7c3-7576-8028-28ed777ba203",
        "storage_key": "property/6767906449162854/019cfdda-e7c3-7576-8028-28ed777ba203.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcYO7IYJ854gReXfj_yDGexM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_31c337be-33b4-4582-8670-bc2a1ebbf51b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Barnett Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4801 W Colonial Dr, Orlando, FL 32808, USA",
      "poi_short_description": "Recreation area with sports fields, disc golf, a playground, hiking and biking trails, and a dog park.",
      "poi_long_description": "Park with trails, disc golf, playgrounds, fitness classes, plus basketball & volleyball courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-cc58-746b-9271-11ee083d1efd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-cc58-746b-9271-11ee083d1efd",
        "storage_key": "property/6767906449162854/019cfdda-cc58-746b-9271-11ee083d1efd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orangecountyfl.net/cultureparks/parks.aspx?m=dtlvw&d=3",
      "poi_directions_map_url": "https://maps.google.com/?cid=15001828583162330551",
      "poi_item_slug": "barnett-park",
      "poi_latitude": "28.5606872",
      "poi_longitude": "-81.443101",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 407-836-6248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e7c3-7576-8028-28ed777ba203.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e7c3-7576-8028-28ed777ba203",
        "storage_key": "property/6767906449162854/019cfdda-e7c3-7576-8028-28ed777ba203.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ27CA7Zp554gRtz2xAJ0zMdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_89bb0a8f-7417-4e8f-a59d-492efb16bdd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Dubsdread Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "549 W Par St, Orlando, FL 32804, USA",
      "poi_short_description": "Golf club featuring an 18-hole course, plus a shop, a restaurant & GolfBoard rentals.",
      "poi_long_description": "Golfers say this golf course offers a challenging course with great greens and a friendly staff, especially in the pro shop. They also highlight the historic charm of the course, with its traditional layout and beautiful city views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-d13e-72c1-80f4-2a7b8ab3f444.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-d13e-72c1-80f4-2a7b8ab3f444",
        "storage_key": "property/6767906449162854/019cfdda-d13e-72c1-80f4-2a7b8ab3f444.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.historicaldubsdread.com/?utm_source=extnet&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=10119554779380907798",
      "poi_item_slug": "dubsdread-golf-course",
      "poi_latitude": "28.5827337",
      "poi_longitude": "-81.38705689999999",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 407-246-2551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e7c2-76e0-9bb0-0b27bb22e7bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e7c2-76e0-9bb0-0b27bb22e7bd",
        "storage_key": "property/6767906449162854/019cfdda-e7c2-76e0-9bb0-0b27bb22e7bd.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJLT54-35654gRFv8axnThb4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_49a9402e-6f5c-43a9-937a-50f45afa6830",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Church St",
      "poi_type": "Transportation & Transit",
      "poi_address": "99 W South St, Orlando, FL 32801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-d5db-72fd-a1e5-9e947517ab34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-d5db-72fd-a1e5-9e947517ab34",
        "storage_key": "property/6767906449162854/019cfdda-d5db-72fd-a1e5-9e947517ab34.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://www.sunrail.com/station/church-street-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16727828110824064533",
      "poi_item_slug": "church-st",
      "poi_latitude": "28.5397556",
      "poi_longitude": "-81.3806525",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-eafa-7510-9e40-594661a7d20c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-eafa-7510-9e40-594661a7d20c",
        "storage_key": "property/6767906449162854/019cfdda-eafa-7510-9e40-594661a7d20c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJNYWT0QF754gRFUZ2-QkvJeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_99a4eaf1-b35b-43e0-b56f-78653378399b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Lynx Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "Orlando, FL 32801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-d6d0-73ee-80b0-28955afb3d9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-d6d0-73ee-80b0-28955afb3d9b",
        "storage_key": "property/6767906449162854/019cfdda-d6d0-73ee-80b0-28955afb3d9b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10911190938460105275",
      "poi_item_slug": "lynx-central",
      "poi_latitude": "28.5485053",
      "poi_longitude": "-81.38093119999999",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-eafa-7510-9e40-594661a7d20c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-eafa-7510-9e40-594661a7d20c",
        "storage_key": "property/6767906449162854/019cfdda-eafa-7510-9e40-594661a7d20c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ15cEsvl654gROypgO1lWbJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_5b71462a-156a-48f3-a15d-ab4c7c3dd9d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "LYNX",
      "poi_type": "Major Employers & Offices",
      "poi_address": "455 N Garland Ave, Orlando, FL 32801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-d5eb-71ad-a10c-4db5251803d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-d5eb-71ad-a10c-4db5251803d6",
        "storage_key": "property/6767906449162854/019cfdda-d5eb-71ad-a10c-4db5251803d6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://lynxpawpass.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15149171819127765980",
      "poi_item_slug": "lynx",
      "poi_latitude": "28.5488856",
      "poi_longitude": "-81.3817702",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 407-841-5969",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_neJfh654gR3Pt3eIGrPNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_68d09348-370a-411b-b9f4-649fc9ff8114",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Kirkman Point 1",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7055 S Kirkman Rd, Orlando, FL 32819, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-da72-77f9-9551-5dbbb068df3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-da72-77f9-9551-5dbbb068df3a",
        "storage_key": "property/6767906449162854/019cfdda-da72-77f9-9551-5dbbb068df3a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16765405644407841317",
      "poi_item_slug": "kirkman-point-1",
      "poi_latitude": "28.4602206",
      "poi_longitude": "-81.4580891",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk3UkqfF-54gRJSJCTpuvqug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_62311137-1061-4465-a4bb-106f93baa38e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Kirkman Point 2",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7012 Grand National Dr, Orlando, FL 32819, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-de7e-74f9-8574-3a7fa042a1e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-de7e-74f9-8574-3a7fa042a1e3",
        "storage_key": "property/6767906449162854/019cfdda-de7e-74f9-8574-3a7fa042a1e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9242562121876039452",
      "poi_item_slug": "kirkman-point-2",
      "poi_latitude": "28.460043",
      "poi_longitude": "-81.4568319",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSzIgiXd_54gRHOfm2EctRIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_64308d47-21b6-4f5a-a167-593339227821",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Universal Creative™ - Creative Village (Commodity)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8523 Commodity Cir, Orlando, FL 32819, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-de58-735e-a317-85d1b72a5371.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfdda-de58-735e-a317-85d1b72a5371",
        "storage_key": "property/6767906449162854/019cfdda-de58-735e-a317-85d1b72a5371.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://universalcreative.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=338672556359684184",
      "poi_item_slug": "universal-creative---creative-village-commodity",
      "poi_latitude": "28.4404199",
      "poi_longitude": "-81.4309078",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu9mlB3l-54gRWBD-SOU0swQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b9057b44-d5d7-47e4-9acc-34e9abc53317",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "custom",
      "poi_name": "Costco Logistics Member Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8301 Southpark Cir, Orlando, FL 32819, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.costco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3880452009975302361",
      "poi_item_slug": "costco-logistics-member-service-center",
      "poi_latitude": "28.4470717",
      "poi_longitude": "-81.4204847",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfdda-e477-755a-b227-024a681adc5e",
        "storage_key": "property/6767906449162854/019cfdda-e477-755a-b227-024a681adc5e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR-3Sxsp954gR2UiHJosi2jU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_5e5ff8da-d35e-4b53-9fd2-a7b008b22cad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_7ff8bed2-780a-4001-832b-2593bab2b2ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_3cd9dd4c-2a3e-44ed-b24d-f3b318f56479",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_69ee8eba-e0b6-4cf5-a530-1f9a93dddc37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_085d19cb-bb26-48af-af93-fe949af7374b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_1214c76e-31d9-48c4-87e9-47f2c20773d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_0a5c849e76aa5a573516a2a1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "rating": "5",
      "name": "false",
      "text": "Living in Citywest was a great first apartment experience. The apartments have a very good home feel to it. My guest are always saying they feel like home when they're over. The staff here are very friendly and cooperative. In my opinion I've been here for almost a year and enjoyed it !",
      "date": "false",
      "title": "Great first apartment"
    },
    {
      "id": "ec_ce076782e5496e58fc3bd85a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "rating": "5",
      "name": "false",
      "text": "the people here are great always helping the residents there like family here understand situation at  hand I love living here it can be touch sometimes but we always seems to get through it.....",
      "date": "false",
      "title": "City West residential"
    },
    {
      "id": "ec_e5e7bd264ecc399d33cf2138",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "rating": "5",
      "name": "false",
      "text": "I have been living here for a few ears now. The recent management which I think took over a few months ago has been really terrific. They are all so nice and pleasure to deal with. They have done a really nice job with the gym and added a locker system for all my amazon orders :)\n\nI would highly recommend!",
      "date": "false",
      "title": "Love it!!!!!!!!!!"
    },
    {
      "id": "ec_8f51216a2ac3483b1b0b2fb2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "rating": "5",
      "name": "false",
      "text": "i just moved in and i had the most amazing experience \napartments are beautiful and service is great !!!",
      "date": "false",
      "title": "Worth every penny "
    },
    {
      "id": "ec_82b00be0b05c56991bb57b16",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "rating": "5",
      "name": "false",
      "text": "I just moved into the two bedroom loft & I love it. I use the upstairs as my office since I work from home. So far my neighbors are quiet. I'm happy with the location to the 408. ",
      "date": "false",
      "title": "I Like My New Place"
    },
    {
      "id": "ec_b4b09312522e77c94e05c6a6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "rating": "4",
      "name": "false",
      "text": "Definitely a good place to live! I haven't had any issues so far, maintenance team seems great unlike my last place I stayed. The office was helpful and made my move in a smooth transition!",
      "date": "false",
      "title": "Good place to live! "
    },
    {
      "id": "ec_f88d8df2a6822d9c6d75960d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "rating": "5",
      "name": "false",
      "text": "Office and maintenance are friendly and very responsive. \n",
      "date": "false",
      "title": "Friendly "
    },
    {
      "id": "ec_fba15373e5ed645b9a60e3ae",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "rating": "5",
      "name": "false",
      "text": "Just renewed my lease, the staff is really helpful, they listen and address any issue really fast. Amenities well kept up and pet friendly. Definitely recommend this place to anyone plus they provide referrals bonus to residents when you recommend someone.  ",
      "date": "false",
      "title": "My 1st Renewal! "
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_399ac1e998c3d4ff1dfc12cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Virtual Tour 1",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/9q4l6w?source=180"
    },
    {
      "id": "ec_3536d1a3fae478a17f8d69ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "1801 Metrowest - Apartments.com",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/1c5o0o?source=180"
    },
    {
      "id": "ec_2470ae5f609524d50c4a8d33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfddc-1d56-75ae-906b-b8f36b732ea4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living room and dining area with modern furniture and decor.",
        "public_id": "019cfddc-1d56-75ae-906b-b8f36b732ea4",
        "storage_key": "property/6767906449162854/019cfddc-1d56-75ae-906b-b8f36b732ea4.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "2BR, 2BA - 1015SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=o2ejGQaFYkX"
    },
    {
      "id": "ec_2721b120e9a3eb03dae4c545",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfddc-1d4d-7077-844c-4275c17a3ea9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern apartment building lobby with a reception desk, seating area, and gym.",
        "public_id": "019cfddc-1d4d-7077-844c-4275c17a3ea9",
        "storage_key": "property/6767906449162854/019cfddc-1d4d-7077-844c-4275c17a3ea9.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UV1cMM2K1Tk"
    },
    {
      "id": "ec_26d7b8c2b9f81a98eea06e1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfddc-1dca-744f-bd5a-1ad4a25a3688.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Gym with treadmills, dumbbells, exercise balls, and stationary bike.",
        "public_id": "019cfddc-1dca-744f-bd5a-1ad4a25a3688",
        "storage_key": "property/6767906449162854/019cfddc-1dca-744f-bd5a-1ad4a25a3688.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DCkTrAJhJtx"
    },
    {
      "id": "ec_d8247678e955caea3f5a35fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019d07f5-0bef-75f5-9b8e-67f45ac9b57e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with fireplace and vaulted ceiling.",
        "public_id": "019d07f5-0bef-75f5-9b8e-67f45ac9b57e",
        "storage_key": "property/6767906449162854/019d07f5-0bef-75f5-9b8e-67f45ac9b57e.webp",
        "width": 1280,
        "height": 720
      },
      "virtual_tour_title": "2BR, 2BA - 1015SF - B2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=rmMJU7maN9q"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198a911-221c-702b-96fc-53d0b3317113",
      "lead_source": "FACEBOOK_ADS",
      "name": "1801 Metrowest facebook ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854"
    },
    {
      "lead_collector_id": "0198a911-22e2-71fc-8f36-b4ce5934fc4e",
      "lead_source": "LANDING_PAGE",
      "name": "1801 Metrowest landing page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854"
    },
    {
      "lead_collector_id": "019953f2-41e2-75dd-9c58-00950a599c03",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "1801 Metrowest Website Lead Form 2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "generator",
      "page_item_url": "resort-style-swimming-pool-apartments-orlando",
      "search_query": "resort-style swimming pool apartments Orlando",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Resort-Style Pool",
      "h2_subtitle": "Discover the ultimate in relaxation at our resort-style swimming pool. Located in Orlando, these apartments offer amenities that feel like a vacation.",
      "page_copy": "Welcome to 1801 Metrowest, where you can enjoy living in a community featuring a resort-style swimming pool that offers endless relaxation and fun right in the heart of Orlando. Our beautifully designed one and two-bedroom apartments provide the perfect blend of comfort and luxury, boasting hardwood floors, stainless steel appliances, and cozy fireplaces for your enjoyment.\n\nBeyond the doors of your home, you'll find world-class amenities including a state-of-the-art fitness center and inviting picnic areas, making every day feel like a holiday. Conveniently located in the vibrant Metro West neighborhood, 1801 Metrowest not only offers a resort-style swimming pool but also quick access to all that Orlando has to offer. Come experience the lifestyle you deserve!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with dark grey sectional sofa, coffee table, and large windows with city view.",
        "public_id": "019cfdda-89ae-730e-bd32-b2506f1aceb7",
        "storage_key": "property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort-Style Swimming Pool Apts in Orlando",
      "seo_description": "Discover 1801 Metrowest: luxury Orlando apartments with resort-style swimming pool and premium amenities in Metro West.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "generator",
      "page_item_url": "fitness-center-apartment-metro-west-orlando",
      "search_query": "fitness center apartment Metro West Orlando",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Metro West",
      "h2_subtitle": "Explore our state-of-the-art fitness center at 1801 Metrowest. Located in Metro West Orlando, enjoy an active lifestyle just steps from home.",
      "page_copy": "Experience an active lifestyle at 1801 Metrowest, where our state-of-the-art fitness center serves as a key amenity for residents. Nestled in the bustling Metro West area of Orlando, these one and two-bedroom apartments offer both luxury and convenience. Each home features modern stainless steel appliances, elegant hardwood floors, and a cozy fireplace, forming the perfect retreat after a workout.\n\nBeyond the luxurious interiors, you'll find the resort-style amenities that enhance daily living, including a sparkling pool and inviting picnic areas. Conveniently situated in the vibrant Metro West neighborhood, this community puts you close to Orlando’s dining, shopping, and entertainment options. Embrace a home that caters to both comfort and fitness at 1801 Metrowest.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with dark grey sectional sofa, coffee table, and large windows with city view.",
        "public_id": "019cfdda-89ae-730e-bd32-b2506f1aceb7",
        "storage_key": "property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Metro West Orlando Apts with Fitness Center",
      "seo_description": "Live actively at 1801 Metrowest, featuring a top-notch fitness center. Located in Metro West Orlando, enjoy convenience and luxury lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-fireplaces-orlando",
      "search_query": "luxury apartments with fireplaces Orlando",
      "category": "Amenity",
      "h1_title": "Orlando Luxury Apartments with Fireplaces",
      "h2_subtitle": "Experience the warmth and elegance of our luxury apartments featuring cozy fireplaces. Located in the heart of Orlando, 1801 Metrowest redefines home comfort.",
      "page_copy": "Discover the epitome of luxury at 1801 Metrowest, where our exquisite apartments with fireplaces enhance your Orlando living experience. Located in the vibrant Metro West neighborhood, these one and two-bedroom homes provide a perfect combination of modern elegance and cozy comfort with their wood-burning fireplaces, hardwood floors, and stainless steel appliances.\n\nAside from the stylish interiors, the community boasts resort-style amenities like a glistening swimming pool, a state-of-the-art fitness center, and charming picnic areas. Whether you seek relaxation or active living, these features make 1801 Metrowest the ideal place to call home in Orlando. Enjoy the warmth and style of these luxury apartments with fireplaces—the perfect retreat after a busy day.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with dark grey sectional sofa, coffee table, and large windows with city view.",
        "public_id": "019cfdda-89ae-730e-bd32-b2506f1aceb7",
        "storage_key": "property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apts with Fireplaces in Orlando",
      "seo_description": "Discover 1801 Metrowest: Orlando’s luxury apartments featuring inviting fireplaces, modern amenities, and resort-style living in Metro West.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-32811",
      "search_query": "pet-friendly apartments 32811",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Orlando 32811",
      "h2_subtitle": "Welcome to our community where pets are family! Located in the 32811 area, our apartments offer pet-friendly living with modern amenities.",
      "page_copy": "At 1801 Metrowest, we understand that pets are an integral part of your family, which is why we offer pet-friendly apartments in Orlando's 32811 zip code. Choose from our spacious one and two-bedroom floor plans that feature elegant hardwood floors, stainless steel appliances, and the cozy touch of a wood-burning fireplace.\n\nBeyond spacious interiors, our community provides resort-style amenities that cater to you and your pets alike. With a sparkling pool, cutting-edge fitness center, and picnic areas, 1801 Metrowest offers everything needed for a fulfilling lifestyle. Located in the lively Metro West neighborhood, our location provides convenient access to all that Orlando has to offer. Come, settle in at a pet-friendly apartment that truly feels like home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with dark grey sectional sofa, coffee table, and large windows with city view.",
        "public_id": "019cfdda-89ae-730e-bd32-b2506f1aceb7",
        "storage_key": "property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Orlando 32811",
      "seo_description": "Discover 1801 Metrowest: pet-friendly Orlando apartments in the 32811 area, offering modern amenities and spacious layouts in Metro West.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "generator",
      "page_item_url": "upgraded-kitchen-apartments-metro-west",
      "search_query": "upgraded kitchen apartments near Metro West",
      "category": "Amenity",
      "h1_title": "Apartments with Upgraded Kitchens in Metro West",
      "h2_subtitle": "Discover luxurious apartments with upgraded kitchens near Metro West. Enjoy modern amenities in a vibrant Orlando neighborhood.",
      "page_copy": "Step into a world of culinary delight at 1801 Metrowest, where our apartments feature upgraded kitchens designed for modern living. Located conveniently near Metro West, these one and two-bedroom homes boast sleek stainless steel appliances, polished countertops, and elegant hardwood floors, creating a stylish and functional space for every meal.\n\nBeyond the inviting kitchens, residents enjoy an array of resort-style amenities. Whether you're taking a dip in the sparkling pool, working out in the state-of-the-art fitness center, or relaxing by the cozy fireplaces, 1801 Metrowest promises a comprehensive living experience. Situated in the bustling hub of Metro West, these upgraded kitchen apartments offer easy access to Orlando’s best dining and entertainment options.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with dark grey sectional sofa, coffee table, and large windows with city view.",
        "public_id": "019cfdda-89ae-730e-bd32-b2506f1aceb7",
        "storage_key": "property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Metro West Apts with Upgraded Kitchens",
      "seo_description": "Explore 1801 Metrowest with upgraded kitchens and stylish amenities. Ideally located near Metro West in Orlando for convenient, luxury living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-metro-west",
      "search_query": "1 bedroom apartments in Metro West",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Metro West Orlando",
      "h2_subtitle": "Find your perfect 1 bedroom apartment in Metro West. Enjoy modern amenities and a convenient Orlando location at 1801 Metrowest.",
      "page_copy": "At 1801 Metrowest, our 1 bedroom apartments in the vibrant Metro West area of Orlando offer the perfect blend of comfort and convenience. These spacious layouts are thoughtfully designed with hardwood floors, stainless steel appliances, and the welcoming warmth of a wood-burning fireplace.\n\nLiving at 1801 Metrowest means enjoying a wealth of amenities such as a sparkling pool, a state-of-the-art fitness center, and inviting picnic areas, all set in a beautifully landscaped community. Located in the bustling Metro West neighborhood, you’ll have easy access to shopping, dining, and entertainment options that Orlando has to offer. Discover the idyllic lifestyle that awaits you in our 1 bedroom apartments today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with dark grey sectional sofa, coffee table, and large windows with city view.",
        "public_id": "019cfdda-89ae-730e-bd32-b2506f1aceb7",
        "storage_key": "property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Metro West, Orlando",
      "seo_description": "Discover spacious 1 bedroom apartments at 1801 Metrowest in Metro West, Orlando, featuring modern amenities and convenient access to the city.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-orlando-fl",
      "search_query": "2 bedroom apartments Orlando FL",
      "category": "Floorplan",
      "h1_title": "Spacious 2 Bedroom Apartments in Orlando, FL",
      "h2_subtitle": "Explore our spacious 2 bedroom apartments in Orlando, FL. Enjoy modern living with resort-style amenities at 1801 Metrowest.",
      "page_copy": "Experience the comfort of spacious 2 bedroom apartments at 1801 Metrowest in beautiful Orlando, FL. Our thoughtfully designed floor plans come with luxurious hardwood floors, state-of-the-art stainless steel appliances, and cozy wood-burning fireplaces, making every day feel like a retreat.\n\nSituated in a prime Orlando location, residents have access to resort-style amenities, including a sparkling pool, a cutting-edge fitness center, and relaxing picnic areas. The Metro West neighborhood offers lively shopping, dining, and entertainment options just minutes away. At 1801 Metrowest, you can enjoy both comfort and convenience in the heart of Orlando, FL.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with dark grey sectional sofa, coffee table, and large windows with city view.",
        "public_id": "019cfdda-89ae-730e-bd32-b2506f1aceb7",
        "storage_key": "property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Orlando, FL",
      "seo_description": "Discover 1801 Metrowest's spacious 2 bedroom apartments in Orlando, FL. Experience modern amenities and convenient living near Metro West.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "generator",
      "page_item_url": "apartments-near-valencia-college-west-campus",
      "search_query": "apartments near Valencia College West Campus Metrowest",
      "category": "School",
      "h1_title": "Apartments Near Valencia College West Campus",
      "h2_subtitle": "Find convenient apartments near Valencia College West Campus in Metro West. Enjoy modern amenities and prime location at 1801 Metrowest.",
      "page_copy": "Located just a short distance from Valencia College West Campus, 1801 Metrowest offers the ideal apartments for students and professionals alike. These beautifully upgraded homes feature spacious one and two-bedroom layouts with modern stainless steel appliances, elegant hardwood floors, and cozy fireplaces, providing a perfect blend of style and function.\n\nLiving at 1801 Metrowest means having convenient access to both educational pursuits and the vibrant lifestyle of the Metro West area. Enjoy resort-like amenities such as a sparkling pool, fully equipped fitness center, and inviting picnic spots, all within a beautifully landscaped community. Experience the best of Orlando living while being just minutes from Valencia College West Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with dark grey sectional sofa, coffee table, and large windows with city view.",
        "public_id": "019cfdda-89ae-730e-bd32-b2506f1aceb7",
        "storage_key": "property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Valencia College West, Metro West",
      "seo_description": "Explore apartments at 1801 Metrowest, near Valencia College West Campus. Perfect for students, with modern amenities in Orlando's Metro West.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "generator",
      "page_item_url": "apartments-near-orlando-health-orlando-regional-medical-center",
      "search_query": "apartments near Orlando Health Orlando Regional Medical Center in Metro West",
      "category": "Hospital",
      "h1_title": "Apts Near Orlando Health Medical Center",
      "h2_subtitle": "Discover convenient apartments near Orlando Health Orlando Regional Medical Center. Enjoy modern living at 1801 Metrowest in Metro West.",
      "page_copy": "For those seeking proximity to Orlando Health Orlando Regional Medical Center, 1801 Metrowest offers the ideal apartments right in the heart of Metro West. Our spacious one and two-bedroom residences provide inviting atmospheres with luxurious hardwood floors, contemporary stainless steel appliances, and charming fireplaces, making it a perfect retreat after a busy day.\n\nRelish the convenience of living close to major healthcare facilities while enjoying resort-style amenities within our community. Experience the refreshing pool, a fully equipped fitness center, and serene picnic areas, all designed to enhance your lifestyle. Located in Metro West, you'll appreciate easy access to shopping, dining, and entertainment venues, ensuring that everything you need is close at hand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with dark grey sectional sofa, coffee table, and large windows with city view.",
        "public_id": "019cfdda-89ae-730e-bd32-b2506f1aceb7",
        "storage_key": "property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Orlando Health Medical Center",
      "seo_description": "Find modern 1801 Metrowest apts near Orlando Health Orlando Regional Medical Center in Metro West, equipped with resort-style amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "generator",
      "page_item_url": "orlando-apartments-close-to-arnold-palmer-hospital",
      "search_query": "Orlando apartments close to Arnold Palmer Hospital for Children 32811",
      "category": "Hospital",
      "h1_title": "Apts Close to Arnold Palmer Hospital in Orlando",
      "h2_subtitle": "Discover Orlando apartments close to Arnold Palmer Hospital for Children in 32811. Enjoy modern living at 1801 Metrowest.",
      "page_copy": "Situated conveniently in the 32811 area, 1801 Metrowest offers apartments that are just a short drive from Arnold Palmer Hospital for Children. Our spacious one and two-bedroom apartments are thoughtfully designed with features like sleek hardwood floors, stainless steel appliances, and cozy fireplaces, providing a perfect sanctuary for relaxation and comfort.\n\nResidents of 1801 Metrowest benefit from a host of resort-style amenities, including a sparkling pool and a state-of-the-art fitness center, ensuring plenty of options for unwinding. The coveted Metro West neighborhood provides a vibrant lifestyle with access to shopping, dining, and entertainment, making it not only convenient for medical professionals but also an ideal choice for families seeking a dynamic Orlando living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with dark grey sectional sofa, coffee table, and large windows with city view.",
        "public_id": "019cfdda-89ae-730e-bd32-b2506f1aceb7",
        "storage_key": "property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Orlando Apts Near Arnold Palmer Hospital 32811",
      "seo_description": "Explore 1801 Metrowest, offering Orlando apts close to Arnold Palmer Hospital for Children in 32811, complete with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "generator",
      "page_item_url": "apartments-near-lake-eola-park-orlando",
      "search_query": "apartments near Lake Eola Park Orlando",
      "category": "Park",
      "h1_title": "Apts Near Lake Eola Park in Orlando",
      "h2_subtitle": "Explore charming apartments near Lake Eola Park in Orlando. Discover modern living at 1801 Metrowest with first-class amenities.",
      "page_copy": "1801 Metrowest offers ideal apartments situated conveniently near the iconic Lake Eola Park in Orlando. Our one and two-bedroom layouts are designed with luxury and comfort in mind, featuring elegant hardwood flooring, modern stainless steel appliances, and intimate fireplaces, making it easy to call this place home.\n\nEnjoy the balance of accessibility and tranquility that comes with living close to Lake Eola Park while benefiting from the resort-style amenities of our community. At 1801 Metrowest, you can relax by the sparkling pool, workout in the state-of-the-art fitness center, or savor the peaceful ambience of our picnic areas. Experience urban living with a touch of nature, perfect for anyone looking to make the most of Orlando’s vibrant city life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with dark grey sectional sofa, coffee table, and large windows with city view.",
        "public_id": "019cfdda-89ae-730e-bd32-b2506f1aceb7",
        "storage_key": "property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Lake Eola Park Orlando",
      "seo_description": "Discover Orlando's 1801 Metrowest apts near Lake Eola Park with elegant interiors and excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "generator",
      "page_item_url": "rentals-close-to-bill-frederick-park-metro-west",
      "search_query": "rentals close to Bill Frederick Park Metro West",
      "category": "Park",
      "h1_title": "Rentals Close to Bill Frederick Park",
      "h2_subtitle": "Find rentals close to Bill Frederick Park in Metro West. Experience excellent amenities and lifestyle at 1801 Metrowest.",
      "page_copy": "Explore the lifestyle awaiting you at 1801 Metrowest, where our rentals are strategically located close to Bill Frederick Park in the desirable Metro West area. Our community offers spacious one and two-bedroom apartments, thoughtfully crafted with features such as hardwood flooring, stainless steel appliances, and fireplaces, providing both style and comfort to suit your needs.\n\nLiving at 1801 Metrowest means enjoying a wealth of resort-style amenities, including a refreshing pool and a modern fitness center. Convenience is key, with Bill Frederick Park just a short distance away, offering ample opportunities for outdoor activities and relaxation. Whether you're seeking active recreation or a peaceful retreat, our location and amenities provide the perfect balance for all lifestyles.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with dark grey sectional sofa, coffee table, and large windows with city view.",
        "public_id": "019cfdda-89ae-730e-bd32-b2506f1aceb7",
        "storage_key": "property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Bill Frederick Park Metro West",
      "seo_description": "Live at 1801 Metrowest in rentals close to Bill Frederick Park in Metro West, featuring upscale amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "generator",
      "page_item_url": "living-near-cypress-grove-park-fl",
      "search_query": "living near Cypress Grove Park FL",
      "category": "Park",
      "h1_title": "Living Near Cypress Grove Park, FL",
      "h2_subtitle": "Experience living near Cypress Grove Park, FL, at 1801 Metrowest. Enjoy modern amenities and a vibrant community in Orlando.",
      "page_copy": "Welcome to 1801 Metrowest, where living near Cypress Grove Park in Florida combines the best of both nature and urban convenience. With stunning one and two-bedroom floor plans, our community offers luxurious hardwood floors, updated stainless steel appliances, and cozy fireplaces. These features make returning home each day a pure delight.\n\nOur premier amenities such as a sparkling pool, state-of-the-art fitness center, and charming picnic areas ensure residents have a perfect balance of activity and relaxation. Proximity to Cypress Grove Park offers an escape into nature, fitting for those who love the outdoors. Whether it's a morning jog, a family picnic, or just a peaceful walk, you’ll cherish the park's beauty while living at 1801 Metrowest.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with dark grey sectional sofa, coffee table, and large windows with city view.",
        "public_id": "019cfdda-89ae-730e-bd32-b2506f1aceb7",
        "storage_key": "property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Cypress Grove Park FL",
      "seo_description": "Discover life at 1801 Metrowest, close to Cypress Grove Park, FL. Enjoy a blend of nature and modern living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162854",
      "source": "generator",
      "page_item_url": "apartment-homes-by-barnett-park-orlando",
      "search_query": "apartment homes by Barnett Park Orlando",
      "category": "Park",
      "h1_title": "Apartment Homes by Barnett Park Orlando",
      "h2_subtitle": "Explore comfortable apartment homes by Barnett Park in Orlando. 1801 Metrowest offers spacious layouts and premium amenities.",
      "page_copy": "Discover the inviting apartment homes at 1801 Metrowest, located conveniently close to Barnett Park in Orlando. Our community provides a selection of one and two-bedroom apartments featuring attractive hardwood flooring, contemporary stainless steel appliances, and charming fireplaces, ensuring a cozy and stylish living experience.\n\nBeyond the impressive interiors, residents enjoy access to a variety of resort-inspired amenities, including a refreshing swimming pool and a fully-equipped fitness center. With Barnett Park just a stone's throw away, you'll have endless opportunities for outdoor adventures and fun activities. This ideal location provides both the excitement of city life and the tranquility of green spaces, making it the perfect place for urban dwellers who love nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
      "featured_image_media": {
        "alt_text": "Modern living room with dark grey sectional sofa, coffee table, and large windows with city view.",
        "public_id": "019cfdda-89ae-730e-bd32-b2506f1aceb7",
        "storage_key": "property/6767906449162854/019cfdda-89ae-730e-bd32-b2506f1aceb7.webp",
        "width": 1920,
        "height": 1080
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes by Barnett Park Orlando",
      "seo_description": "Enjoy life at 1801 Metrowest, apartment homes by Barnett Park in Orlando. Spacious living spaces with modern amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_boolean",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_fielder",
      "type": "STRING",
      "value": "123"
    },
    {
      "ID": "custom_test_text_type_field",
      "type": "STRING",
      "value": "hallo"
    },
    {
      "ID": "custom_custom_text_field_from_company_level",
      "type": "STRING",
      "value": "hallo"
    }
  ],
  "custom_boolean": "true",
  "custom_fielder": "123",
  "custom_test_text_type_field": "hallo",
  "custom_custom_text_field_from_company_level": "hallo"
};

export const generatedAt = '2026-10-05T18:29:39.800Z';
